/**
 * Sets up Google Tag Manager
 */
import importscript from "./import-script.js";
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/attributes/data/data.js";
import cookie from "./cookie.js";

function gtag() { // google does some weird voodoo to this function which consents will not work without
	window.dataLayer.push(arguments);
}

function setConsent(type, consent) {
	const map = {
		website: "functionality_storage",
		analytics: "analytics_storage",
		adstorage: "ad_storage",
		addata: "ad_user_data",
		adpersonalisation: "ad_personalization"
	},
		setting = {};
	for (const item in map) {
		if (map[item]) {
			setting[map[item]] = consent.includes(item) ? "granted" : "denied";
		}
	}
	gtag("consent", type, setting);
}

export default gtm => {
	if (gtm) {
		let id = gtm.id || gtm,
			attr = {},
			consent = type => {
				setConsent(type, (cookie.get("cookiepreferences") || "").split(","));
			};
		window.dataLayer = [];

		// set consent
		consent("default");

		// send start command
		window.dataLayer.push({
			"gtm.start": new Date().getTime(),
			event: "gtm.js"
		});

		// set GTM information
		if (typeof gtm !== "string") {
			delete gtm.id;
			if (gtm.nonce) {
				attr.nonce = gtm.nonce;
				delete gtm.nonce;
			}
			if (Object.keys(gtm).length) {
				window.dataLayer.push(gtm);
			}
		}

		// capture push events
		$("[data-gtm-event]").each(function () {
			window.dataLayer.push($(this).data("gtm-event"));
		});

		// update cookies
		$("html").on("cookies.updated", () => {
			consent("update");
			window.dataLayer.push({event: "consent_update"}); // escape need this . . . ?
		});

		// import script
		importscript("https://www.googletagmanager.com/gtm.js?id="+id, null, attr);
	}
};
